<template>
  <div :class="containerClass">
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";
import { PropOptions } from "vue";

@Component({ name: "cat-row" })
export default class CatRow extends Vue {
  @Prop({
    type: String,
    default: null,
    description:
      "Optional - one of 'padding' or 'margin' applied to the cells, if not provided then there is no spacing between the cells."
  } as PropOptions<any>)
  readonly gutters?: string;
  @Prop({
    type: [String, Array],
    default: null,
    description:
      "One of or array of: 'auto', 'grow', 'shrink', 'left', 'right', 'top', 'bottom', 'middle', 'center'. Will align the cells accordingly - horizontally or vertically (based on flex css)"
  } as PropOptions<any>)
  readonly align?: string | object;
  @Prop({
    type: [String, Array],
    default: null,
    description: "Deprecated property"
  } as PropOptions<any>)
  readonly alignContent?: string | object;
  @Prop({
    type: [String, Array],
    default: null,
    description: "Deprecated property"
  } as PropOptions<any>)
  readonly justify?: string | object;

  get containerClass(): object {
    let self = this;
    let classes = {
      "cat-row": true,
      "grid-x": true,
      ["grid-" + this.gutters + "-x"]: this.gutters,
      ["align-content-" + this.alignContent]: this.alignContent,
      ["justify-content-" + this.justify]: this.justify
    };
    if (Array.isArray(this.align) && this.align.length > 0) {
      this.align.forEach(function (item, index) {
        if (self.align && self.align[index]) {
          classes["flex-align-" + self.align[index]] =
            self.align[index] !== null;
        }
      });
    } else {
      classes["flex-align-" + this.align] =
        this.align !== null && this.align !== "";
    }

    return classes;
  }
}
</script>
